import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";

const SuccessModal = ({ message, closeModal }) => {
  return (
    <div>
      <div className="flex w-full  max-w-sm mx-auto overflow-hidden bg-white rounded-lg shadow-md dark:bg-gray-800">
        <div className="w-10 flex items-center justify-center md:w-12 bg-green-500">
          <svg
            className="w-6 h-6 text-white fill-current"
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z" />
          </svg>
        </div>
        <div className="flex w-full justify-between items-center px-2 py-2 md:px-4 ">
          <div className="mx-3 mt-2">
            <span className="font-semibold text-green-500 dark:text-green-400">
              Success
            </span>
            <p className="text-sm text-gray-600 dark:text-gray-200">{message}</p>
          </div>
          <button onClick={closeModal}>
            <AiFillCloseCircle size="1.3rem" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
